










































import { Component, Mixins } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

// Mixins
import Form from '@/mixins/Form'
import Errors from '@/mixins/Errors'
import Phone from '@/mixins/Phone'

// Components
import InputPassword from '@/components/common/InputPassword.vue'
import ModalWrapper from '@/components/common/ModalWrapper.vue'

// Views
import ConfirmPhoneNumberForm from '@/views/profile/forms/ConfirmPhoneNumberForm.vue'

@Component({
  components: {
    ModalWrapper,
    ConfirmPhoneNumberForm
  }
})
export default class EditAccountProfile extends Mixins(Form, Errors, Phone) {
  phone: string = null
  phoneModalActive = false
  update: boolean = false
  displayErrors: any

  @Getter('profile', { namespace: 'user' }) user
  @Action('updatePhoneNumber', { namespace: 'user' }) updatePhoneNumber

  closeModale(state) {
    if (!state.code || !state.valid) {
      this.$toast.open({
        message: this.$t('profile.add_phone.notification.warning.title') as string,
        type: 'is-danger',
        duration: 5000
      })
    }

    if (state.verified && state.code && state.valid) {
      this.$toast.open({
        message: this.$t('profile.check_phone.success.title') as string,
        type: 'is-success',
        duration: 5000
      })
    }

    this.phoneModalActive = false
  }

  get phoneNumber() {
    return this.user.phone || this.phone
  }

  confirm() {
    this.phoneModalActive = true
  }

  async submit() {
    await this.submitPhoneNumber(this.phone)
  }

  async submitPhoneNumber(phone) {
    try {
      await this.$validator.validateAll()
      this.formLoading = true
      this.updatePhoneNumber(phone)
      this.phoneModalActive = true
    } catch (error) {
      this.displayErrors(error)
    } finally {
      this.update = false
      this.formLoading = false
    }
  }
}
